/**
 * Copyright © WarmHeart Intelligence Technology Group (Jiangsu) Co.,Ltd Company, Limited.
 * All Rights Reserved
 */
import url from "./conf";
import {post, tokenPost} from "./ajax";

const unit = {
  /**
   *  AJAX-获取单位列表
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  listMaterialUnit(success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.LIST_MATERIAL_UNIT,
      {},
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-添加单位
   * @param unitName
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  addMaterialUnit(unitName, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.ADD_MATERIAL_UNIT,
      {
        unitName: unitName,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-删除单位
   * @param id
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  removeMaterialUnit(id, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.REMOVE_MATERIAL_UNIT,
      {
        id: id,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },

}

export default unit;



// WEBPACK FOOTER //
// ./src/assets/ajax/ajax-unit.js